import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: [],
    cross: [],
    isolated: [],
    convertTo: [],
    convertedCurrencies: []
};
function accountBalanceResource(data) {
    return {
        currency: data.currency,
        balance: data.balance,
        available: data.available,
        borrowed: data.borrowed,
        pairName: data.pairName
    };
}
function accountBalanceCrossResource(data) {
    return {
        currency: data.currency,
        balance: data.balance,
        available: data.available,
        borrowed: data.borrowed,
        interest: data.interest
    };
}
function balanceCurrencyResource(data) {
    var broker = {
        id: data.broker.id,
        name: data.broker.name,
        separator: data.broker.separator,
        hasUniqueTradeId: data.broker.hasUniqueTradeId
    };
    return {
        id: data.id,
        name: data.name,
        convert: data.convert,
        broker: broker,
        unique: data.unique
    };
}
export var AccountBalancesReducer = createSlice({
    name: 'accountBalances',
    initialState: initialState,
    reducers: {
        set: function set(state, accountBalances) {
            var resource = [];
            accountBalances.payload.forEach(function (element) {
                resource.push(accountBalanceResource(element));
            });
            state.data = resource;
        },
        setCross: function setCross(state, accountBalances) {
            var resource = [];
            accountBalances.payload.forEach(function (element) {
                resource.push(accountBalanceCrossResource(element));
            });
            state.cross = resource;
        },
        setIsolated: function setIsolated(state, accountBalances) {
            state.isolated = accountBalances.payload;
        },
        setBalanceCurrencies: function setBalanceCurrencies(state, balanceCurrencies) {
            var resource = [];
            balanceCurrencies.payload.forEach(function (element) {
                resource.push(balanceCurrencyResource(element));
            });
            state.convertTo = resource;
        },
        setConvertedCurrencies: function setConvertedCurrencies(state, convertedCurrencies) {
            state.convertedCurrencies = convertedCurrencies.payload;
        }
    }
});
var _AccountBalancesReduc = AccountBalancesReducer.actions, set = _AccountBalancesReduc.set, setBalanceCurrencies = _AccountBalancesReduc.setBalanceCurrencies, setConvertedCurrencies = _AccountBalancesReduc.setConvertedCurrencies, setCross = _AccountBalancesReduc.setCross, setIsolated = _AccountBalancesReduc.setIsolated;
export { set, setBalanceCurrencies, setConvertedCurrencies, setCross, setIsolated };
export default AccountBalancesReducer.reducer;
